'use es6';

/**
 * @param {Axis} axis (reporting-visualizations)
 * @param {Scale} scale (RelationalReport)
 * @returns {Axis}
 */
export const applyScaleToAxis = (axis, scale) => {
  const {
    min,
    max
  } = scale;
  const hasAnyValue = min != null || max != null;
  return axis.update('startOnTick', startOnTick => hasAnyValue ? false : startOnTick).set('min', min).set('max', max);
};